<template>
  <div>
    <hero id="hero" />
    <about-us id="about-us" />
    <WhatWeOffer id="what-we-offer"/>
    <AssetTracking id="asset-tracking"/>
    <DigitalLogging id="digital-logging"/>
    <ITSolutions id="it-solutions"/>
    <RealDemoExperience id="real-demo-experience"/>
    <DemoContext id="demo-context"/>
    <contact-us id="contact-us" />
  </div>
</template>

<script>
import Hero from "./home/Hero";
import AboutUs from "./home/AboutUs";
import WhatWeOffer from "./home/WhatWeOffer.vue";
import AssetTracking from "./home/AssetTracking.vue";
import DigitalLogging from "./home/DigitalLogging.vue";
import ITSolutions from "./home/ITSolutions.vue";
import ContactUs from "./home/ContactUs";
import RealDemoExperience from "./home/RealDemoExperience.vue";
import DemoContext from "./home/DemoContext.vue";

export default {
  name: "home",
  components: {
    Hero,
    AboutUs,
    WhatWeOffer,
    AssetTracking,
    DigitalLogging,
    ITSolutions,
    ContactUs,
    RealDemoExperience,
    DemoContext
},
};
</script>